import loadable from '@loadable/component';
import Animation from './Animation';

export const Root = Animation;
export const Ripple = loadable(() => import('./src/Ripple'));
export const ShimmerInputPrimary = loadable(() => import('./src/ShimmerInputPrimary'));
export const ShimmerInputSecondary = loadable(() => import('./src/ShimmerInputSecondary'));
export const Spinner = loadable(() => import('./src/Spinner'));
